<template>
    <div class="footer">
        <div class="footerDiv">
            <div class="left">
                <span>热线电话：0874-6881555</span>
                <span style="margin-right:0;">开放时间：08:30-18:30</span>
                <br>
                <span>景区地址：云南省曲靖市陆良县城西南20公里</span>
                <span style="margin-right:0;">邮政编码：655699</span>
                <br>
                <span>版权所有：@2018 All Rights Rserved 云南曲靖陆良彩色沙林智慧景区</span>
            </div>
            <div class="right">
                <div style="margin-left:10px">
                    <img src="../../assets/images/wx.jpg" alt="">
                    <p>官网微信</p>
                </div>
                <!-- <div>
                    <img src="../../assets/images/wx.jpg" alt="">
                    <p>官方微博</p>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import store from "@/vuex/store";
    export default {
        name: 'footerTail',
        data() {
            return {
                
            }
        },
        store
    }
</script>

<style lang="stylus" scoped>
.footer{
    // background-color: #16365C;
    background: url('../../assets/images/bg.jpg')
    background-size: cover
    background-repeat :no-repeat
    background-position: center
    position relative
    z-index 2
    width 100%
    color: #333;
    .footerDiv{
        box-sizing: border-box;
        width: 1200px;
        height: 280px;
        margin: 0 auto;
        font-size: 14px;
        .left{
            float: left;
            padding-top: 74px;
            span{
                margin: 0 14px 25px 0;
                display: inline-block;
            }
        }
        .right{
            float: right;
            padding-top: 53px;
            text-align: center;
            >div{
                float: left;
                margin-left: 34px;
                >img{
                    width: 136px;
                }
            }
            p{
                margin-top: 10px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/footerTail.vue